import { render, staticRenderFns } from "./objek.vue?vue&type=template&id=329aa656&"
import script from "./objek.vue?vue&type=script&lang=js&"
export * from "./objek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports